// extracted by mini-css-extract-plugin
export default {"pageContainer":"PasswordReset_pageContainer__1Mff4","bottomSpacer":"PasswordReset_bottomSpacer__PgY2a"};